import { render, staticRenderFns } from "./CargoExpenseKanbanCard.vue?vue&type=template&id=67bc07d4"
import script from "./CargoExpenseKanbanCard.vue?vue&type=script&lang=js"
export * from "./CargoExpenseKanbanCard.vue?vue&type=script&lang=js"
import style0 from "./CargoExpenseKanbanCard.vue?vue&type=style&index=0&id=67bc07d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports